
import { combineReducers } from 'redux';
import { requests } from './requests/requests.reducer'
import { TTDrequests } from './ttd-requests/ttd-requests.reducer'

export const services = combineReducers({
    requests,
    TTDrequests
});
